export default {
  compose: (state) => state.compose,
};
